module.exports = "/_next/static/images/Mobile-Solutions-57fb14c4afe01946b4106b9a28283bca.jpg";